import React, { useEffect } from "react";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useTranslation } from "react-i18next";
import { Portal } from "../../components/Portal";

const MessageConfirmModal = ({
  show,
  title,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onClose,
  variant = "primary",
  isLoading = false,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!show) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.body.classList.add("modal-open");

    const handleKeyDown = (event) => {
      if (event.key === "Escape" && !isLoading) onClose();
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.classList.remove("modal-open");
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [show, onClose, isLoading]);

  if (!show) return null;

  return (
    <Portal layer="modal">
      <div
        className="message-confirm-modal-backdrop"
        onClick={() => !isLoading && onClose()}
        role="presentation"
      >
        <div
          className="message-confirm-modal"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-labelledby="message-confirm-title"
        >
          <div className="message-confirm-modal-header">
            <h6 id="message-confirm-title" className="mb-0 f-15 f-600">
              {title}
            </h6>
            <button
              type="button"
              className="message-confirm-close-btn"
              onClick={onClose}
              disabled={isLoading}
              aria-label={cancelLabel || t("Connections.Cancel")}
            >
              <CloseSharpIcon className="material-symbols-sharp" />
            </button>
          </div>

          <div className="message-confirm-modal-actions">
            <button
              type="button"
              className="message-confirm-btn message-confirm-btn-cancel"
              onClick={onClose}
              disabled={isLoading}
            >
              {cancelLabel || t("Connections.Cancel")}
            </button>
            <button
              type="button"
              className={`message-confirm-btn message-confirm-btn-${variant}`}
              onClick={onConfirm}
              disabled={isLoading}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default MessageConfirmModal;
